export default {
  signals: {
    css: {
      label: {
        notes: 'Label for CSS signal',
        message: 'CSS',
      },
    },
    cssSetPoint: {
      label: {
        notes: 'Label for CSS set point signal',
        message: 'CSS set point',
      },
    },
    pressureAvg: {
      label: {
        notes: 'Label for pressure avg signal',
        message: 'Pressure avg',
      },
    },
    pressurePeakAvg: {
      label: {
        notes: 'Label for pressure peak avg signal',
        message: 'Average peak pressure',
      },
    },
    pressureSetPoint: {
      label: {
        notes: 'Label for pressure set point signal',
        message: 'Pressure set point',
      },
    },
    powerAvg: {
      label: {
        notes: 'Label for power average signal',
        message: 'Power average',
      },
    },
    powerSetPoint: {
      label: {
        notes: 'Label for power set point signal',
        message: 'Power set point',
      },
    },
    oilTemp: {
      label: {
        notes: 'Label for oil temperature signal',
        message: 'Return oil temperature',
      },
    },
    position: {
      label: {
        notes: 'Label for a-dimension signal',
        message: 'A-dimension',
      },
    },
  },
  controlMode: {
    autoload: {
      notes: 'Mode "autoload" in automation system for cone crushers',
      message: 'Autoload',
    },
    autoCss: {
      notes: 'Mode "autocss" in automation system for cone crushers',
      message: 'Auto CSS',
    },
    multiCss: {
      notes: 'Mode "multicss" in automation system for cone crushers',
      message: 'Multi CSS',
    },
    unknown: {
      notes: 'Unknown mode in automation system for cone crushers',
      message: 'Unknown control mode',
    },
  },
};
